// Randomizing the Avatars for local development.

const avatarDir = 'common/avatars/';

// TODO: ENG-2061 make this a const enum
// to add another avatar, put the new png in into the folder and increment the constant below
const maxNumberOfAvatars = 40;

let currentAvatarIndex = 0;
function getNextAvatarUrl() {
  currentAvatarIndex = (currentAvatarIndex % maxNumberOfAvatars) + 1;
  return `${avatarDir}avatars_photo_avatar-${currentAvatarIndex}.jpg`;
}

function getNextAvatarUrlSet() {
  return [getNextAvatarUrl(), getNextAvatarUrl(), getNextAvatarUrl(), getNextAvatarUrl()];
}

// Avatars can come from multiple sets and can be randomized.
// We are going to have an array of arrays containing the sources of avatar images.
export type AvatarSourceSet = ReadonlyArray<ReadonlyArray<string>>;

// Putting images into an array so that they can be randomized in the Avatar component.
export const avatarImageSet: AvatarSourceSet = [
  getNextAvatarUrlSet(),
  getNextAvatarUrlSet(),
  getNextAvatarUrlSet(),
  getNextAvatarUrlSet(),
  getNextAvatarUrlSet(),
  getNextAvatarUrlSet(),
  getNextAvatarUrlSet(),
  getNextAvatarUrlSet(),
  getNextAvatarUrlSet(),
  getNextAvatarUrlSet(),
  [getNextAvatarUrl()],
];

/*
  Generates random number from min (inclusive) to max (inclusive)
*/
export function generateRandomInclusive(min: number, max: number) {
  return Math.floor(Math.random() * (max - min + 1) + min);
}
